import React__default from 'react';
import { DataLayer, CartV2Actions } from '@grandvisionhq/analytics';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { isNil } from '@grandvisionhq/utils';
import { getUnappliedVoucherCodes } from '../utils/get-unapplied-voucher-codes.js';
import { useCartStorage } from './use-cart-storage.js';
import { mapLineItemToDataLayerEvent } from '../mappers/analytics/data-layer/line-item-to-data-layer-event.js';
import { createProductObject } from '../mappers/analytics/structured-data-mapper.js';
import { REMOVE_CART_LINE_ITEMS } from '../operations/mutations/remove-cart-line-items.js';
import { GET_CART } from '../operations/queries/get-cart.js';

const useRemoveFromCart = (lineItem, onSuccess)=>{
    const [{ cartId  }, { setCartCount  }] = useCartStorage();
    const [removeCartItems, removeCartLineItemsMutation] = useMutation(REMOVE_CART_LINE_ITEMS, {
        onCompleted: ()=>{
            const dataLayerEvents = mapLineItemToDataLayerEvent(DataLayer.DataLayerTypes.EventType.remove, [
                lineItem
            ], cartId || '');
            dataLayerEvents && DataLayer.pushEcommerceEvent(dataLayerEvents);
            CartV2Actions.removeLineItemsSdAction([
                createProductObject(lineItem)
            ]);
            onSuccess && onSuccess();
        }
    });
    const removeFromCart = React__default.useCallback(()=>{
        if (isNil(cartId)) {
            console.error('No cart ID available');
            return;
        }
        removeCartItems({
            variables: {
                cartInput: {
                    cartId,
                    lineItems: [
                        {
                            id: lineItem.id
                        }, 
                    ]
                }
            },
            update (cache, { data  }) {
                if (data && data.removeCartLineItems.success === true) {
                    var ref;
                    const newCart = data.removeCartLineItems.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: {
                            id: cartId
                        },
                        data: newCart
                    });
                    if (newCart === null || newCart === void 0 ? void 0 : (ref = newCart.vouchers) === null || ref === void 0 ? void 0 : ref.length) {
                        const unappliedVouchers = getUnappliedVoucherCodes(newCart === null || newCart === void 0 ? void 0 : newCart.vouchers, newCart === null || newCart === void 0 ? void 0 : newCart.appliedDiscounts);
                        if (unappliedVouchers === null || unappliedVouchers === void 0 ? void 0 : unappliedVouchers.length) {
                            toast.failed('cart.validations.discountcode.doesnotmatchcart');
                        }
                    }
                    setCartCount((newCart === null || newCart === void 0 ? void 0 : newCart.numberOfItems) || 0);
                }
            }
        });
    }, [
        lineItem
    ]);
    const { called , loading , error  } = removeCartLineItemsMutation;
    return [
        removeFromCart,
        {
            called,
            loading,
            error
        }
    ];
};

export { useRemoveFromCart };
//# sourceMappingURL=use-remove-from-cart.js.map
